var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"data-table-pagination"},[_c('div',{staticClass:"list"},[_c('ul',_vm._l((_vm.pagination.totalPages),function(page){return _c('li',{key:page,class:{
          active: page === _vm.pagination.currentPage,
          disabled: page === _vm.pagination.totalPages
        },on:{"click":function($event){return _vm.onClick(page)}}},[_vm._v(" "+_vm._s(page)+" ")])}),0)])])}
var staticRenderFns = []

export { render, staticRenderFns }